export interface IStorage {
  readonly size: number;

  get(key: string): any;
  set(key: string, value: any): void;
  remove(key: string): void;
  clear(): void;
}

class SafeStorage implements IStorage {
  get size(): number { return this.storage.length; }

  constructor(private storage: Storage) { }

  get(key: string): any {
    const value = this.storage.getItem(key);
    if (value == null) return null;

    return JSON.parse(value);
  }
  set(key: string, value: any): void {
    if (value == null) return this.storage.removeItem(key);
    this.storage.setItem(key, JSON.stringify(value));
  }
  remove(key: string): void { this.storage.removeItem(key); }
  clear(): void { this.storage.clear(); }
}

export default new SafeStorage(localStorage) as IStorage;
